import { Map, Set } from 'immutable';
import { INITIALIZE_CASH_PRICE } from './actions';
import { VIEW_LEAVE } from '../../containers/openBets/actions';

const initialState = new Map({
  betIds: new Set([])
});

export default (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_CASH_PRICE: {
      const { id } = action;
      let betIds = state.get('betIds');
      if (!betIds.has(id)) {
        betIds = betIds.add(id);
      }

      return state.set('betIds', betIds);
    }
    case VIEW_LEAVE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
